module.exports = __webpack_public_path__ + "img/user-icon-input.9742e36f.svg";